import React from 'react';
import { Scale, ExternalLink } from 'lucide-react';
import type { SearchGuidelinesWidgetData } from '../../../types/agentWidgets';

interface Props {
  data: SearchGuidelinesWidgetData;
}

export const SearchGuidelinesWidget: React.FC<Props> = ({ data }) => {
  if (data.results.length === 0) return null;

  return (
    <div className="mt-1.5 space-y-1">
      <p className="text-[10px] uppercase tracking-wide text-gray-400 dark:text-gray-500 font-medium">
        {data.results.length} guideline{data.results.length !== 1 ? 's' : ''}
      </p>
      <div className="space-y-1">
        {data.results.map((g) => (
          <a
            key={g.id}
            href={g.url}
            target="_blank"
            rel="noopener noreferrer"
            className="flex items-center gap-2 text-[11px] bg-teal-50/70 dark:bg-teal-900/10 rounded px-2 py-1.5 group hover:bg-teal-100/70 dark:hover:bg-teal-900/20 transition-colors"
          >
            <Scale className="h-3 w-3 text-teal-500 dark:text-teal-400 flex-shrink-0" />
            <span className="text-[10px] font-mono text-teal-600 dark:text-teal-400 whitespace-nowrap">
              {g.id}
            </span>
            <span className="font-medium text-teal-700 dark:text-teal-300 truncate flex-1 min-w-0">
              {g.title}
            </span>
            <ExternalLink className="h-2.5 w-2.5 text-teal-400 dark:text-teal-500 flex-shrink-0 opacity-0 group-hover:opacity-100 transition-opacity" />
          </a>
        ))}
      </div>
    </div>
  );
};
